"use strict";

export const tasksCode = [
    { name: "Transcriber", code: "transcriber" },
    { name: "Transcriber", code: "transcribe" },

    { name: "Translator", code: "translate" },
    { name: "Translator", code: "translator" },

    { name: "Performance Direction", code: "performancedirection" },
    { name: "Face ID Editor", code: "speakerfaceidentification" },
    { name: "Lip QA Reviewer", code: "lipqualityassurance" },
    { name: "Final QA Reviewer", code: "qualityassurance" },
];

export const tasksCodeFormal = [
    { name: "Transcriber", code: "transcriber" },
    { name: "Transcribe", code: "transcribe" },

    { name: "Translate", code: "translate" },
    { name: "Translator", code: "translator" },

    { name: "Performance Direction", code: "performancedirection" },

    { name: "Attribution", code: "attribution" },
    { name: "Face ID Editing", code: "speakerfaceidentification" },
    { name: "Lip QA Review", code: "lipqualityassurance" },
    { name: "Final QA Review", code: "qualityassurance" },
];

export const workTypes = [
    "transcribe",
    "translate",
    "performancedirection",
    "attribution",
    "speakerfaceidentification",
    "lipqualityassurance",
    "qualityassurance",
];

export const videoAdminRoles = [
    "transcribe",
    "translate",
    "performancedirection",
    "attribution",
    "speakerfaceidentification",
    "lipqualityassurance",
    "qualityassurance",
];

export const audioAdminRoles = ["performancedirection", "finalqa"];

export const videoRoleOrder = [
    "transcriber",
    "translator",
    "performancedirection",
    "performancedirector",
    "attribution",
    "attributioneditor",
    "speakerfaceidentification",
    "faceideditor",
    "lipqualityassurance",
    "lipsqa",
    "qualityassurance",
    "qa",
];

export const audioRoleOrder = [
    "performancedirection",
    "performancedirector",
    "finalqa",
    "qualityassurance",
    "qa",
];

export const roleLabels = {
    transcribe: "Transcribe",
    transcriber: "Transcribe",
    translate: "Translate",
    translator: "Translate",
    performancedirection: "Direct Performance",
    performancedirector: "Direct Performance",
    attribution: "Edit Attribution",
    attributioneditor: "Edit Attribution",
    speakerfaceidentification: "Identify Faces",
    faceideditor: "Identify Faces",
    lipqualityassurance: "QA Lipsync",
    lipsqa: "QA Lipsync",
    qualityassurance: "QA Final",
    qa: "QA Final",
    finalqa: "QA Final",
};

export const roleEmojis = {
    transcribe: "📝",
    transcriber: "📝",
    translate: "🌐",
    translator: "🌐",
    performancedirection: "🎬",
    performancedirector: "🎬",
    attribution: "🏷️",
    attributioneditor: "🏷️",
    speakerfaceidentification: "👤",
    faceideditor: "👤",
    lipqualityassurance: "👄",
    lipsqa: "👄",
    qualityassurance: "✅",
    qa: "✅",
    finalqa: "✅",
};

export const languageSpecificRoles = new Set([
    "translate",
    "translator",
    "performancedirection",
    "performancedirector",
    "lipqualityassurance",
    "lipsqa",
    "qualityassurance",
    "qa",
    "finalqa",
]);

